var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWomen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EC4899",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.5C12.5 11.5683 14.0683 10 16 10C17.9317 10 19.5 11.5683 19.5 13.5C19.5 15.4317 17.9317 17 16 17C14.0683 17 12.5 15.4317 12.5 13.5ZM17 18.9094C19.5594 18.4406 21.5 16.1969 21.5 13.5C21.5 10.4625 19.0375 8 16 8C12.9625 8 10.5 10.4625 10.5 13.5C10.5 16.1969 12.4406 18.4406 15 18.9094V20H14C13.4469 20 13 20.4469 13 21Cnan nan 13.4469 22 14 22H15V23C15 23.5531 15.4469 24 16 24Cnan nan 17 23.5531 17 23V22H18C18.5531 22 19 21.5531 19 21Cnan nan 18.5531 20 18 20H17V18.9094Z",
    fill: "#F472B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomen);
export default __webpack_public_path__ + "static/media/women.e310148ef2306a1c31fc2f28f26ad6aa.svg";
export { ForwardRef as ReactComponent };